export function AdminPermission({ children }) {
  return children;
}
